import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../components/Layout/layout";
import PostListContainer from "../postList";
import PostDetail from "../../components/postDetail";
import { Route, Routes } from "react-router-dom";
import { withRouter } from "../../../utils/withRouter";
import ProtectedRoute from "../../../Auth/components/ProtectedRoute";

const Posts = () => (
  <ProtectedRoute>
    <main>
    <Helmet title="Viewsparks" />
    <Layout>
      <Routes>
        <Route path="/" element={<PostListContainer />} />
        <Route path={`new/:donorId?/:donationId?`} element={<PostDetail />} />
        <Route path={`:postType/:postId`} element={<PostDetail />} />
      </Routes>
    </Layout>
    </main>
  </ProtectedRoute>
);

export default withRouter(Posts);
